/*
 * Wraps `widow-js` in a helper so it won’t fail during server-side rendering
 */
try {
  if(window) 
     module.exports = require('widow-js');
}  
catch(ex) 
{
 module.exports = function(){};
}